import React from "react";
import { Container, Message } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import { useLocation } from "react-router-dom";

const Error: React.FC = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const error = queryParams.get("error");

    return (
        <Container text style={{ marginTop: "50px" }}>
            <Message negative>
                <Message.Header>{error}</Message.Header>
                <p>Please reload page.</p>
            </Message>
        </Container>
    );
};

export default Error;
